import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatDate(date: string, locale: string): string {
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) {
    return date;
  }

  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(parsed);
}

export function buildMailto(baseHref: string, subject: string, body: string): string {
  const hasQuery = baseHref.includes('?');
  const connector = hasQuery ? '&' : '?';
  const subjectParam = `subject=${encodeURIComponent(subject)}`;
  const bodyParam = `body=${body}`;
  return `${baseHref}${connector}${subjectParam}&${bodyParam}`;
}
